module.exports = __webpack_public_path__ + "static/media/PlantillaDatos.645f2888.xlsx";